import React, {Component} from 'react';
import {Modal, Button, Tooltip} from 'antd';
import DeviceCmdAir from './DeviceCmdAir'
import IconLamp from '../style/icon/IconLamp'
import IconLampChandelier from '../style/icon/IconLampChandelier'
import IconLampCeilling from '../style/icon/IconLampCeilling'
import IconLampCompact from '../style/icon/IconLampCompact'
import IconLampSleep from '../style/icon/IconLampSleep'
import IconLampDecor from '../style/icon/IconLampDecor'
import IconHeater from '../style/icon/IconHeater'
import IconPump from '../style/icon/IconPump'
import IconFan1 from '../style/icon/IconFan1'
import IconFan2 from '../style/icon/IconFan2'
import IconFanCeilling from '../style/icon/IconFanCeilling'
import IconAirController from '../style/icon/IconAirController'
import IconCurtainClosed from '../style/icon/IconCurtainClosed'
import IconCurtainOpened from '../style/icon/IconCurtainOpened'
import IconWarning from '../style/icon/IconWarning'
import IconSiren from '../style/icon/IconSiren'

import {timeAgoVnShortFromEpochTime} from '../utils'

import {
  SUB_CATEGORY_LAMP,
  SUB_CATEGORY_LAMP_COMPACT,
  SUB_CATEGORY_LAMP_SLEEP,
  SUB_CATEGORY_LAMP_TABLE,
  SUB_CATEGORY_LAMP_CEILLING,
  SUB_CATEGORY_LAMP_DECOR,
  SUB_CATEGORY_LAMP_CHANDELIER,
  SUB_CATEGORY_FAN_1,
  SUB_CATEGORY_FAN_2,
  SUB_CATEGORY_FAN_CEILLING,
  SUB_CATEGORY_OUTLET,
  SUB_CATEGORY_WATERING,
  SUB_CATEGORY_HEATER,
  SUB_CATEGORY_BELL,
  SUB_CATEGORY_ALARM_BELL,
  SUB_CATEGORY_DO_NOT_DISTURB,
  SUB_CATEGORY_CURTAIN,
  SUB_CATEGORY_AIR_CONTROLLER,
  SUB_CATEGORY_PUMP,
  DEVICE_STATUS_STATE_ON,
  DEVICE_STATUS_COLOR_ON,
  COMMAND_OFF,
  COMMAND_ON,
  COMMAND_OPEN,
  COMMAND_CLOSE,
  COMMAND_PAUSE
} from '../constants/defaultValues'

class ModalDeviceRelay extends Component {
  displayDevice(dev) {
    switch (dev.SubCategory) {
      case SUB_CATEGORY_ALARM_BELL:
        return <IconSiren color={dev.Color} size="lg"/>
      case SUB_CATEGORY_LAMP:
      case SUB_CATEGORY_LAMP_TABLE:
      case SUB_CATEGORY_OUTLET:
      case SUB_CATEGORY_WATERING:
      case SUB_CATEGORY_BELL:
      case SUB_CATEGORY_DO_NOT_DISTURB:
        return <IconLamp color={dev.Color} size="lg"/>
      case SUB_CATEGORY_LAMP_CHANDELIER:
        return <IconLampChandelier color={dev.Color} size="lg"/>
      case SUB_CATEGORY_LAMP_COMPACT:
        return <IconLampCompact color={dev.Color} size="lg"/>
      case SUB_CATEGORY_LAMP_SLEEP:
        return <IconLampSleep color={dev.Color} size="lg"/>
      case SUB_CATEGORY_LAMP_CEILLING:
        return <IconLampCeilling color={dev.Color} size="lg"/>
      case SUB_CATEGORY_LAMP_DECOR:
        return <IconLampDecor color={dev.Color} size="lg"/>
      case SUB_CATEGORY_HEATER:
        return <IconHeater color={dev.Color} size="lg"/>
      case SUB_CATEGORY_PUMP:
        return <IconPump color={dev.Color} size="lg"/>
      case SUB_CATEGORY_FAN_1:
        return <IconFan1 color={dev.Color} size="lg"/>
      case SUB_CATEGORY_FAN_2:
        return <IconFan2 color={dev.Color} size="lg"/>
      case SUB_CATEGORY_FAN_CEILLING:
        return <IconFanCeilling color={dev.Color} size="lg"/>
      case SUB_CATEGORY_AIR_CONTROLLER:
        return <IconAirController color={dev.Color} size="lg"/>
      case SUB_CATEGORY_CURTAIN:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          return <IconCurtainOpened color={dev.Color} size="lg"/>
        } else {
          return <IconCurtainClosed color={dev.Color} size="lg"/>
        }
      default:
        return <span>{dev.Name}</span>
    }
  }

  handleCmd = (deviceID, cmd) => {
    this.props.onCmd(deviceID, cmd)
  }
  handleTimeLineClick = (dev) => {
    this.props.onTimeLineClick(dev)
  }
  render() {
    const {visible, onCancel, device, sending} = this.props

    const icon = this.displayDevice(device)
    const roomName = device.RoomName && device.RoomName !== "Default"
      ? device.RoomName.toLowerCase()
      : ""
    const deviceName = device && device.Name !== ""
      ? device.Name
      : ""
    const title = `${deviceName} ${roomName}`
    const disconnected = device.Disconnected
    const {time, inHours} = timeAgoVnShortFromEpochTime(device.Time)
    const timeColor = inHours === true
      ? {
        color: DEVICE_STATUS_COLOR_ON
      }
      : null
    return (<Modal visible={visible} title={title} onCancel={onCancel} footer={[<Button key="cancel" onClick={onCancel}>Bỏ qua</Button>
        ]}>
      <div className="form-device-relay">
        <div className="box-device">
          <div>
            <span className="text" style={{
                color: device.Color
              }}>{device.Text}</span>
            <span className="time" style={timeColor}>{time}</span>
          </div>
          <span className="line-chart">
            <Tooltip placement="left" title="Lịch sử trạng thái">
              <Button type="primary" ghost={true} shape="circle" icon="bar-chart" onClick={() => this.handleTimeLineClick(device)}></Button>
            </Tooltip>
          </span>
          {icon}
          {
            disconnected
              ? <div className="value">
                  <span className="disconnected"><IconWarning/></span>
                </div>
              : null
          }
          {
            device.SubCategory === SUB_CATEGORY_CURTAIN
              ? <div>
                  <Button shape="circle" size="large" disabled={sending || disconnected} onClick={() => this.handleCmd(device.DeviceId, COMMAND_CLOSE)}>Đóng</Button>
                  <Button shape="circle" size="large" disabled={sending || disconnected} style={{
                      color: DEVICE_STATUS_COLOR_ON
                    }} onClick={() => this.handleCmd(device.DeviceId, COMMAND_OPEN)}>Mở</Button>
                  <Button shape="circle" size="large" disabled={sending || disconnected} onClick={() => this.handleCmd(device.DeviceId, COMMAND_PAUSE)}>Dừng</Button>
                </div>
              : device.SubCategory === SUB_CATEGORY_AIR_CONTROLLER
                ? <DeviceCmdAir device={device} sending={sending} onCmd={this.handleCmd}/>
                : <div>
                    <Button shape="circle" size="large" disabled={sending || disconnected} style={{
                        color: DEVICE_STATUS_COLOR_ON
                      }} onClick={() => this.handleCmd(device.DeviceId, COMMAND_ON)}>Bật</Button>
                    <Button shape="circle" size="large" disabled={sending || disconnected} onClick={() => this.handleCmd(device.DeviceId, COMMAND_OFF)}>Tắt</Button>
                  </div>
          }
        </div>
      </div>
    </Modal>);
  }
}
export default ModalDeviceRelay;



// WEBPACK FOOTER //
// ./src/components/ModalDeviceRelay.js